import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Text } from '@rsos/components/capstone/base';
import { IconWrapper } from '../../Main.styles';
import { ErrorWrapper } from '../Modal.styles';

export const ErrorContainer = ({ primaryText, secondaryText }) => {
  return (
    <ErrorWrapper align="baseline" mb={3}>
      <IconWrapper color={'lightDanger'} px={2} pt={1}>
        <AttentionTriangleIcon height={15} width={15} />
      </IconWrapper>
      <Text color="primaryText">
        <Text color={'lightDanger'} fontWeight="regular">
          {primaryText}
        </Text>
        {secondaryText && (
          <Text color={'lightDanger'} fontWeight="regular">
            {secondaryText}
          </Text>
        )}
      </Text>
    </ErrorWrapper>
  );
};
